var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.125 36.7188H71.0865V20.6582C71.0865 9.26719 61.6238 0 49.9928 0C38.3617 0 28.899 9.26719 28.899 20.6582V36.7188H21.875C15.4133 36.7188 10.1562 41.9758 10.1562 48.4375V88.2812C10.1562 94.743 15.4133 100 21.875 100H78.125C84.5867 100 89.8438 94.743 89.8438 88.2812V48.4375C89.8438 41.9758 84.5867 36.7188 78.125 36.7188ZM36.7115 20.6582C36.7115 13.575 42.6695 7.8125 49.9928 7.8125C57.316 7.8125 63.274 13.575 63.274 20.6582V36.7188H36.7115V20.6582ZM82.0312 88.2812C82.0312 90.4352 80.2789 92.1875 78.125 92.1875H21.875C19.7211 92.1875 17.9688 90.4352 17.9688 88.2812V48.4375C17.9688 46.2836 19.7211 44.5312 21.875 44.5312H78.125C80.2789 44.5312 82.0312 46.2836 82.0312 48.4375V88.2812Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 55.8594C46.0088 55.8594 42.7734 59.0947 42.7734 63.0859C42.7734 65.6344 44.0937 67.873 46.0865 69.1598V77.7344C46.0865 79.8916 47.8354 81.6406 49.9928 81.6406C52.15 81.6406 53.899 79.8916 53.899 77.7344V69.1689C55.8998 67.8838 57.2266 65.6406 57.2266 63.0859C57.2266 59.0947 53.9912 55.8594 50 55.8594Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockLarge);
export default __webpack_public_path__ + "static/media/padlock-large.f32dec14a731d53b590d83500265c4e0.svg";
export { ForwardRef as ReactComponent };